import {
  ICalculationGuestUpdate,
  IPaymentListItem,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

import { ICalculationPaymentUpdate } from '../models/ICalculationPaymentUpdate';

interface IProps {
  calculationId: string;
  paymentId?: string;
  //   payload: ICalculationPaymentUpdate;
  payload: any;
}

export const upsertCalculationPayment = ({
  calculationId,
  paymentId,
  payload,
}: IProps): Promise<IPaymentListItem[]> => {
  if (paymentId === undefined) {
    return API.post(`api/accommodation/calculations/${calculationId}/payment`, payload).then(
      response => response?.data,
    );
  }

  return API.put(`api/accommodation/calculations/payments/${paymentId}`, payload).then(
    response => response?.data,
  );
};
